import React, { useState } from 'react';
import CameraBlur from './CameraBlur';

function App() {
  const [bg, setBg] = useState('blur');

  return (
    <div>
      <h2>Background Mode</h2>
      <select value={bg} onChange={e => setBg(e.target.value)}>
        <option value="blur">Blur</option>
        <option value="black">Black</option>
        <option value="green">Green</option>
        <option value="#3498db">Blue</option>
        <option value="https://picsum.photos/id/1015/640/480">Scenic Image</option>
      </select>

      <CameraBlur background="https://fastly.picsum.photos/id/1015/640/480.jpg?hmac=jvtkb6auuHevAjhwo6VgREyZdAav9tOdAIY2vJDYS6I" width={640} height={480} />
    </div>
  );
}

export default App;
